import React from 'react'

import { Link, T } from 'govwell-ui'
import { ViewDataRowFragment } from 'types/graphql'

import { routes } from '@redwoodjs/router'

type Props = {
  row: ViewDataRowFragment
}

const SettlementCell = ({ row }: Props) => {
  const settlement = row.settlement
  if (!settlement?.uuid) {
    return <T.Body>-</T.Body>
  }

  return (
    <Link
      internalRoute={routes.settlement({
        settlementUuid: settlement.uuid,
      })}
    >
      {settlement.finixSettlementId}
    </Link>
  )
}

export default React.memo(SettlementCell)
